var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('g', [_c('path', {
    attrs: {
      "d": "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
      "opacity": ".4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m13.061 12 2.47-2.47a.75.75 0 0 0-1.061-1.061L12 10.939l-2.47-2.47a.75.75 0 1 0-1.061 1.06l2.47 2.47-2.47 2.47a.75.75 0 0 0 1.06 1.062l2.47-2.47 2.47 2.47a.748.748 0 0 0 1.06 0 .75.75 0 0 0 0-1.061L13.061 12Z"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }